// extracted by mini-css-extract-plugin
module.exports = {"formSection":"form-section_formSection__pB2fG","title":"form-section_title__3klEh","content":"form-section_content__1WCac"};